// Componente per sistema ExeDialog DDT2026 - Step temperatura
import React, { useState, useRef, useEffect } from 'react';
import { InputNumber } from 'primereact/inputnumber';
import { ValoriVerificati } from './ValoriVerificati';

export function Temperatura(props) {
    const { currURLSearchParams, onFinish, verificaData } = props;
    const inputRef = useRef();
    
    const [temperatura, setTemperatura] = useState(
        currURLSearchParams.get('temperatura') 
            ? parseInt(currURLSearchParams.get('temperatura'), 10) 
            : null
    );

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.getInput().focus();
        }
    }, [verificaData]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (temperatura !== null && temperatura > 0) {
            onFinish({ temperatura });
        }
    };

    return (
        <div className="card-body">
            <h5 className="card-title">Temperatura</h5>
            <p className="text-muted">Inserisci la temperatura (valore positivo).</p>
            
            <form onSubmit={handleSubmit}>
                <div className="mb-3">
                    <label htmlFor="temperatura" className="form-label">Temperatura (°C)</label>
                    <InputNumber 
                        ref={inputRef}
                        id="temperatura"
                        value={temperatura}
                        onValueChange={(e) => setTemperatura(e.value)}
                        min={1}
                        showButtons
                        suffix=" °C"
                        className="w-100"
                    />
                </div>

                <button className="btn btn-primary" disabled={temperatura === null || temperatura <= 0}>
                    Prosegui
                </button>
            </form>
            
            <ValoriVerificati valori={verificaData?.valori_verificati} />
        </div>
    );
}

Temperatura.displayName = 'temperatura';
